import { render } from "./ViewMatrimonyListing.vue?vue&type=template&id=197092a2"
import script from "./ViewMatrimonyListing.vue?vue&type=script&lang=js"
export * from "./ViewMatrimonyListing.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__